/**
  * @prop --component-map-marker-scaling: Scaling of the markers
 */

:host {
  display: block;
  position: relative;

  .content {
    position: absolute;
    pointer-events: none;
    left: 50%;
  }
}

:host([variant='main']),
:host([variant='place']) {
  width: calc(48px * var(--component-map-marker-scaling, 1));

  .marker > svg {
    width: calc(48px * var(--component-map-marker-scaling, 1));
    filter: drop-shadow(0 3px 1px rgb(0 0 0 / 20%));
  }

  .content {
    top: 0%;
    transform: translateX(-50%);
  }
}

:host([variant='place']) {
  .marker > svg {
    transition: all 0.2s ease-in-out;
    fill: var(--skin-color-white, white);

    &:hover {
      fill: var(
        --ui-color-blue-100,
        var(--skin-color-primary-lighter, $ui-blue-minus-5)
      );
    }

    &:active {
      fill: var(
        --ui-color-blue-300,
        var(--skin-color-primary-lighter, $ui-blue-minus-4)
      );
    }
  }
}

:host([variant='place'][state='hover']) {
  .marker > svg {
    fill: var(
      --ui-color-blue-100,
      var(--skin-color-primary-lighter, $ui-blue-minus-5)
    );

    &:active {
      fill: var(
        --ui-color-blue-300,
        var(--skin-color-primary-lighter, $ui-blue-minus-4)
      );
    }
  }
}

:host([variant='place'][state='active']) {
  .marker > svg {
    fill: var(
      --ui-color-blue-300,
      var(--skin-color-primary-lighter, $ui-blue-minus-4)
    );
  }
}

:host([variant='main']) {
  .marker > svg {
    fill: var(--skin-color-accent, $ui-green);
  }
}

:host([variant='cluster']) {
  width: calc(48px * var(--component-map-marker-scaling, 1));
  height: calc(48px * var(--component-map-marker-scaling, 1));
  font-size: calc(14px * var(--component-map-marker-scaling, 1));

  .marker {
    transition: all 0.2s ease-in-out;
    fill: var(--skin-color-primary, $ui-blue);

    &:hover {
      transform: scale(1.15);
    }
  }

  .content {
    top: 50%;
    transform: translate(-50%, -50%);
    color: var(--skin-color-white, $ui-white);
  }
}

// Defaults for ui-icon in place marker
::slotted(ui-icon) {
  margin-top: calc(7px * var(--component-map-marker-scaling, 1));
  width: calc(32px * var(--component-map-marker-scaling, 1));
  height: calc(32px * var(--component-map-marker-scaling, 1));
}
